
import React, { useState, useEffect } from "react";
import "./styles.css";
import Post from "./post";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import {Button, Input} from "@material-ui/core";
import { db, auth, storage } from "./Firebase";
import ImageUpload from "./ImageUpload";
import InstagramEmbed from "react-instagram-embed";


function getModalStyle() {
  const top = 50 ;
  const left = 50 ;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 250,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function App() {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [posts, setPosts] = useState([]);
  const [opensignin, setOpensignin] = useState(false);
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authuser) => {
      if(authuser){
        //console.log(authuser);
        setUser(authuser);
        if(authuser.displayName){

        }else{
          return authuser.updateProfile({
            displayName: username
          });
        }
      }
      else
      {
        setUser(null);
      }
    })
    return () => {unsubscribe();} 
  }, [user, username ]);

  useEffect(() => {  
    db.collection('posts').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
      setPosts(snapshot.docs.map(doc => ({key:doc.id ,id: doc.id, post: doc.data()})));
    })
  }, []);

function signup(event){
  event.preventDefault();

  auth.createUserWithEmailAndPassword(email, password)
  .then((authuser) => {
    return authuser.user.updateProfile({
      displayName: username
    })
  })
  .catch((err) => alert(err));
}

  const body = (
    <div >
      <div style={modalStyle} className={classes.paper}>
        <form>
          <center>
            <img
              alt=""
              className="app-headerimage"
              src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
            />
            <Input 
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Input 
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input 
              type="text"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            
            <Button onClick={signup}>Sign Up</Button>
          </center>
        </form>
        
      </div>
    </div>
  );

  function signin(event){
    event.preventDefault();

    auth.signInWithEmailAndPassword(email, password)
    .catch((err) => alert(err))

    setOpensignin(false);
  }

  const bodytwo = (
    <div >
      <div style={modalStyle} className={classes.paper}>
        <form>
          <center>
            <img
              alt=""
              className="app-headerimage"
              src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
            />
            
            <Input 
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input 
              type="text"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            
            <Button onClick={signin}>Login</Button>
          </center>
        </form>
        
      </div>
    </div>
  );

  return (
    <div className="app">
      

      
      <div className="app-header">
        <img
          alt=""
          className="app-headerimage"
          src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
        />
        {user ? 
              <Button onClick={() => auth.signOut()}>Sign Out</Button> :
              <div className="app__logincontainer"> 
                <Button type="button" onClick={() => setOpensignin(true)}>
                  Login
                </Button>
                <Button type="button" onClick={handleOpen}>
                  Sign Up
                </Button>
              </div>
        }
      </div>
      <div>
        
        
        <Modal
          open={open}
          onClose={handleClose}
        >
          {body}
        </Modal>
        <Modal
          open={opensignin}
          onClose={() => setOpensignin(false)}
        >
          {bodytwo}
        </Modal>
      </div>
      <div className="app_post">
        <div className="app_postleft"> 
          {posts.map(function ({id, post}) {
            return (
              <Post
                user={user}
                key={id}
                postid={id}
                username={post.username}
                imageUrl={post.imageUrl}
                comments={post.caption}
              />
            );
          })}
        </div>
        <div className="app_postright">
        <InstagramEmbed
            url='https://www.instagram.com/p/CD9vbU-ME4JTVRIZWTrmRv50JmM43OoSrPhN-k0/'
            clientAccessToken='3301370349989178|73f0264339b52f2bcc50a9ea68e55775'
            maxWidth={320}
            hideCaption={false}
            containerTagName='div'
            protocol=''
            injectScript
            onLoading={() => {}}
            onSuccess={() => {}}
            onAfterRender={() => {}}
            onFailure={() => {}}
            />

        </div>
      </div>
            {user ? 
        <ImageUpload username={user}/> : 
        <h2>Login To Upload</h2>
      }


    </div>
  );
}